module.exports = __webpack_public_path__ + "static/media/quoteMark.9fe7c228.svg";